import axios from "axios";
import { AuthenticationService, AppSettingsService } from "@services";

export default class ConfigurationService {
  static classInstance = null;
  static getInstance() {
    if (ConfigurationService.classInstance === null) {
      ConfigurationService.classInstance = new ConfigurationService();
    }
    return this.classInstance;
  }

  async getConfiguration(configRequest) {
    const apiUrl = AppSettingsService.getInstance().getApiUrl();
    const url = `${apiUrl}configuration`;
    const headers = await AuthenticationService.getInstance().getHeaders();
    const config = await axios.post(`${url}`, configRequest, headers).then(
      (response) => {
        return response.data;
      },
      (error) => {
        console.error(error);
      }
    );
    return config;
  }
  async getPatientConfiguration(configRequest) {
    const apiUrl = AppSettingsService.getInstance().getApiUrl();
    const url = `${apiUrl}patientfinderconfig`;
    const headers = await AuthenticationService.getInstance().getHeaders();
    const config = await axios.post(`${url}`, configRequest, headers).then(
      (response) => {
        return response.data;
      },
      (error) => {
        console.error(error);
      }
    );
    return config;
  }
}
